import { SHARE_WITH_FRIEND_REQUEST, SHARE_WITH_FRIEND_SUCCESS, SHARE_WITH_FRIEND_FAILURE } from '../types';

const initialState = {
  status: 'initial',
  error: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SHARE_WITH_FRIEND_REQUEST:
      return {
        ...state,
        status: 'fetching',
      };
    case SHARE_WITH_FRIEND_SUCCESS:
      return {
        ...state,
        status: 'success',
      };
    case SHARE_WITH_FRIEND_FAILURE:
      return {
        ...state,
        status: 'failure',
      };
    default:
      return state;
  }
}
